module.exports = __webpack_public_path__ + "media/images/emblems/Seeberg-coat_of_arms-7d2367ff26eba5c81980b602f356b77e.svg";